var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoActualite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ico-actualite_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(1490.021 271.021)",
    fill: "#01182c",
    d: "M0 0h30v30H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1490.021 -271.021)",
    clipPath: "url(#ico-actualite_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ico-news"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 167",
    d: "M1510.553 272.258a1.32 1.32 0 00-1.328.605c-4.692 7.427-9.534 8.727-16.236 10.528a1.108 1.108 0 00-.783 1.355l1.65 6.152a1.11 1.11 0 001.356.782l1.428-.383a38.313 38.313 0 011.833 5.263c.17.632.321 1.26.452 1.872a1.492 1.492 0 001.87 1.144l.115-.03 1.173-.413a1.646 1.646 0 001.039-1.967l-.034-.127-.03-.068a32.417 32.417 0 01-2.606-6.561c4.37-.828 8.462-.691 14.088 2.262a1.322 1.322 0 00.962.11 1.352 1.352 0 00.493-.25 1.324 1.324 0 00.455-1.393l-4.8-17.903a1.324 1.324 0 00-1.097-.978zm-3.528 5.191l3.311 12.35a20.641 20.641 0 00-11.364-.13l-1.723-6.425a20.637 20.637 0 009.776-5.795zm-12.185 13.185l-1.65-6.152a.088.088 0 01.063-.107c1.05-.281 2.054-.55 3.02-.834l1.707 6.365c-.978.241-1.983.51-3.031.79a.088.088 0 01-.109-.062zm7.292 6.774l.005.02a.622.622 0 01-.392.742l-1.172.412a.5.5 0 01-.414-.025.494.494 0 01-.236-.337 39.63 39.63 0 00-.465-1.921 39.39 39.39 0 00-1.818-5.256 55.334 55.334 0 011.806-.428 33.425 33.425 0 002.686 6.793zm13.33-6.004a.31.31 0 01-.11.333.306.306 0 01-.341.034 29.066 29.066 0 00-3.512-1.575l-3.664-13.665a29.14 29.14 0 002.253-3.122.3.3 0 01.177-.134.333.333 0 01.136-.007.312.312 0 01.261.233z",
    fill: "#01182c"
  })))));
}

export default SvgIcoActualite;